import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import './CareerModal.css';
import axios from 'axios';
const CareerModal = ({ show, handleClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    cv: null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      const response = await axios.post('https://geegaresources.com/sendEmail.php', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      alert(response.data);
    } catch (error) {
      console.error('There was an error sending the email!', error);
    }
  };


  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Submit Your Application</Modal.Title>
      </Modal.Header>
      <form
        onSubmit={handleSubmit}
      >
        {/* Hidden FormSubmit fields */}
        <input type="hidden" name="_subject" value="Career Application" />
        <input type="hidden" name="_captcha" value="false" />
        
        <Modal.Body>
          {/* <label >Name:</label> */}
          <input
          
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Full Name"
          />
          {/* <label>Email:</label> */}
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="Email"
          />
          {/* <label>Phone Number:</label> */}
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            placeholder="Phone number"
          />
          {/* <label>Message:</label> */}
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            //required
            placeholder="Cover letter"
          ></textarea>
          <label>Attach CV:</label>
          <input
            type="file"
            name="cv"
            onChange={handleChange}
            // accept=".pdf,.doc,.docx"
            required
          />
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button> */}
          <Button variant="primary" type="submit" style={{backgroundColor:"#ff8c00"}}>
            Submit Application
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default CareerModal;
